import { render, staticRenderFns } from "./FilterDropdown.vue?vue&type=template&id=23267b28&scoped=true&"
import script from "./FilterDropdown.vue?vue&type=script&lang=js&"
export * from "./FilterDropdown.vue?vue&type=script&lang=js&"
import style0 from "./FilterDropdown.vue?vue&type=style&index=0&id=23267b28&prod&lang=scss&scoped=true&"
import style1 from "./FilterDropdown.vue?vue&type=style&index=1&id=23267b28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23267b28",
  null
  
)

export default component.exports